module.exports = __webpack_public_path__ + "img/deleteWrap.f9d92dc2.png";